var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "home",
      class: _vm.$vuetify.breakpoint.smAndDown ? "mt-6" : ""
    },
    [
      _c(
        "v-flex",
        [
          _c(
            "v-row",
            {
              staticClass: "ma-3 px-3 pt-3 pb-0",
              attrs: { align: "center", justify: "center" }
            },
            [
              _c(
                "v-col",
                {
                  staticClass: "mx-auto mt-5",
                  attrs: { cols: "12", xs: "6", lg: "12" }
                },
                [
                  _c(
                    "v-card",
                    {
                      attrs: {
                        color: _vm.colorPainel,
                        shaped: "",
                        outlined: "",
                        block: "",
                        elevation: "1",
                        "max-width": "calc(100%)"
                      }
                    },
                    [
                      _c(
                        "v-row",
                        {
                          staticClass: "d-flex align-center",
                          attrs: { "no-gutters": "" }
                        },
                        [
                          _c(
                            "v-col",
                            {
                              staticClass: "d-flex align-center",
                              staticStyle: {
                                flex: "1 1 auto",
                                "min-width": "0"
                              },
                              attrs: { cols: "auto" }
                            },
                            [
                              _c(
                                "v-card-title",
                                {
                                  staticClass:
                                    "title font-weight-normal ml-5 mb-0",
                                  staticStyle: { "padding-right": "24px" },
                                  style: {
                                    color: _vm.dashboardColorFontTitle
                                  }
                                },
                                [
                                  _c(
                                    "v-icon",
                                    {
                                      staticClass: "mr-3",
                                      attrs: { color: "white" }
                                    },
                                    [_vm._v(" mdi-dots-grid ")]
                                  ),
                                  _c(
                                    "div",
                                    {
                                      class: _vm.$vuetify.breakpoint.smAndDown
                                        ? "text-subtitle-1 font-weight-bold ml-4"
                                        : ""
                                    },
                                    [
                                      _vm._v(
                                        " Olá " +
                                          _vm._s(_vm.computedGetUserName) +
                                          " "
                                      )
                                    ]
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _c(
                            "v-col",
                            {
                              class: {
                                "d-flex align-center justify-end": !_vm.isMobile,
                                "d-flex align-center justify-center":
                                  _vm.isMobile
                              },
                              style: {
                                "min-width": _vm.isMobile ? "100%" : "220px",
                                "max-width": _vm.isMobile ? "100%" : "250px",
                                "margin-top": "15px",
                                "margin-right": _vm.isMobile ? "0" : "24px"
                              },
                              attrs: { cols: "auto" }
                            },
                            [
                              _c("v-select", {
                                staticClass: "white--text periodo-select",
                                style: {
                                  "min-width": _vm.isMobile ? "80%" : "180px",
                                  "max-width": _vm.isMobile ? "80%" : "none"
                                },
                                attrs: {
                                  items: _vm.periodoOptions,
                                  label: "Período",
                                  outlined: "",
                                  dense: "",
                                  disabled: _vm.isMobile,
                                  color: "white",
                                  "background-color": "white",
                                  "label-color": "white",
                                  "hide-details": ""
                                },
                                on: { change: _vm.onPeriodoChange },
                                model: {
                                  value: _vm.periodoSelecionado,
                                  callback: function($$v) {
                                    _vm.periodoSelecionado = $$v
                                  },
                                  expression: "periodoSelecionado"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "v-row",
            { staticClass: "mt-0 mb-2", class: _vm.rowMarginClass },
            [
              _c(
                "v-col",
                { attrs: { cols: "12" } },
                [
                  _c(
                    "v-card",
                    [
                      _c(
                        "v-card-title",
                        { staticClass: "pb-2" },
                        [
                          _c("v-icon", { attrs: { left: "" } }, [
                            _vm._v("mdi-filter")
                          ]),
                          _vm._v(" Filtros ")
                        ],
                        1
                      ),
                      _c(
                        "v-card-text",
                        { staticClass: "pt-0" },
                        [
                          _c(
                            "v-row",
                            { attrs: { align: "center" } },
                            [
                              _c(
                                "v-col",
                                {
                                  staticClass: "d-flex flex-row align-center",
                                  attrs: {
                                    cols: "12",
                                    sm: "6",
                                    md: "4",
                                    lg: "4"
                                  }
                                },
                                [
                                  _c("v-autocomplete", {
                                    staticClass: "flex-grow-1",
                                    attrs: {
                                      loading: _vm.loadingCedentesSacadores,
                                      outlined: "",
                                      dense: "",
                                      label: "Nome do Cedente",
                                      hint:
                                        "Selecione um cedente para filtrar os dados",
                                      placeholder: "Ex.: João Silva",
                                      clearable: "",
                                      items: _vm.cedentesSacadores,
                                      "item-text": "nm_cedente_favorecido",
                                      "item-value": "nm_cedente_favorecido",
                                      "no-data-text":
                                        "Nenhum cedente encontrado",
                                      "hide-details": "auto"
                                    },
                                    on: { input: _vm.onCedenteChange },
                                    model: {
                                      value: _vm.filtros.nm_cedente,
                                      callback: function($$v) {
                                        _vm.$set(_vm.filtros, "nm_cedente", $$v)
                                      },
                                      expression: "filtros.nm_cedente"
                                    }
                                  })
                                ],
                                1
                              ),
                              _c(
                                "v-col",
                                {
                                  staticClass: "d-flex flex-row align-center",
                                  attrs: {
                                    cols: "12",
                                    sm: "6",
                                    md: "4",
                                    lg: "4"
                                  }
                                },
                                [
                                  _c("v-autocomplete", {
                                    staticClass: "flex-grow-1",
                                    attrs: {
                                      loading: _vm.loadingCedentesSacadores,
                                      outlined: "",
                                      dense: "",
                                      label: "Nome do Sacador",
                                      hint:
                                        "Selecione um sacador para filtrar os dados",
                                      placeholder: "Ex.: Maria Santos",
                                      clearable: "",
                                      items: _vm.sacadoresFiltrados,
                                      "item-text": "nm_sacador",
                                      "item-value": "nm_sacador",
                                      "no-data-text":
                                        "Nenhum sacador encontrado",
                                      "hide-details": "auto"
                                    },
                                    on: { input: _vm.onSacadorChange },
                                    model: {
                                      value: _vm.filtros.nm_sacador,
                                      callback: function($$v) {
                                        _vm.$set(_vm.filtros, "nm_sacador", $$v)
                                      },
                                      expression: "filtros.nm_sacador"
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "v-row",
            { staticClass: "mt-0 mb-4", class: _vm.rowMarginClass },
            [
              _c(
                "v-col",
                {
                  staticClass: "mt-6 pt-0 px-4 pb-4",
                  attrs: { cols: "12", xs: "12", lg: "6" }
                },
                [
                  _c(
                    "v-card",
                    { staticStyle: { height: "100%" } },
                    [
                      _c(
                        "v-sheet",
                        {
                          staticClass: "v-sheet--offset mx-auto",
                          attrs: {
                            color: _vm.colorPainel,
                            elevation: "1",
                            width: "calc(100% - 32px)"
                          }
                        },
                        [
                          _c(
                            "v-card-title",
                            {
                              staticClass: "white--text title font-weight-bold"
                            },
                            [
                              _vm._v(
                                " Upload de Títulos Efetivados no Sistema "
                              ),
                              _c(
                                "v-tooltip",
                                {
                                  attrs: { top: "" },
                                  scopedSlots: _vm._u([
                                    {
                                      key: "activator",
                                      fn: function({ on, attrs }) {
                                        return [
                                          _c(
                                            "v-icon",
                                            _vm._g(
                                              _vm._b(
                                                {
                                                  staticClass: "my-auto ml-1",
                                                  attrs: {
                                                    small: "",
                                                    color: "white"
                                                  }
                                                },
                                                "v-icon",
                                                attrs,
                                                false
                                              ),
                                              on
                                            ),
                                            [_vm._v(" help ")]
                                          )
                                        ]
                                      }
                                    }
                                  ])
                                },
                                [
                                  _c("span", [
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "font-weight-regular white--text caption"
                                      },
                                      [
                                        _vm._v(
                                          " Dados pertencentes a somatória de todos os títulos com upload efetivado no sistema dentro dos últimos " +
                                            _vm._s(
                                              _vm.periodoOptions.find(
                                                opt =>
                                                  opt.value ===
                                                  _vm.periodoSelecionado
                                              )?.text || ""
                                            ) +
                                            " "
                                        ),
                                        _c("b", [
                                          _vm._v(
                                            "(títulos irregulares não inclusos)"
                                          )
                                        ])
                                      ]
                                    )
                                  ])
                                ]
                              )
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "v-row",
                        [
                          _c(
                            "v-col",
                            { attrs: { cols: "12" } },
                            [
                              _c("Loading", {
                                attrs: {
                                  active: _vm.carregandoTotalUploads,
                                  "is-full-page": false
                                }
                              }),
                              _c(
                                "div",
                                { staticClass: "ma-3" },
                                [
                                  !_vm.hasChartData(_vm.dataTotalUpload)
                                    ? _c(
                                        "div",
                                        [
                                          _c(
                                            "v-alert",
                                            {
                                              class: _vm.isPartner
                                                ? "bvs-white-label"
                                                : "",
                                              attrs: {
                                                type: "info",
                                                dense: "",
                                                text: ""
                                              }
                                            },
                                            [
                                              _vm._v(
                                                " Nenhum dado disponível para o período selecionado. "
                                              )
                                            ]
                                          )
                                        ],
                                        1
                                      )
                                    : _c("chartTotalUploads", {
                                        staticClass: "mt-5",
                                        staticStyle: {
                                          "background-color": "white"
                                        },
                                        attrs: {
                                          height: 300,
                                          "chart-data": _vm.dataTotalUpload
                                        }
                                      })
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "v-col",
                {
                  staticClass: "mt-6 pt-0 px-4 pb-4",
                  attrs: { cols: "12", xs: "12", lg: "6" }
                },
                [
                  _c(
                    "v-card",
                    { staticStyle: { height: "100%" } },
                    [
                      _c(
                        "v-sheet",
                        {
                          staticClass: "v-sheet--offset mx-auto",
                          attrs: {
                            color: _vm.colorPainel,
                            elevation: "1",
                            width: "calc(100% - 32px)"
                          }
                        },
                        [
                          _c(
                            "v-card-title",
                            {
                              staticClass: "white--text title font-weight-bold"
                            },
                            [
                              _vm._v(
                                " Desistências, Cancelamentos, Anuências e Pagos "
                              ),
                              _c(
                                "v-tooltip",
                                {
                                  attrs: { top: "" },
                                  scopedSlots: _vm._u([
                                    {
                                      key: "activator",
                                      fn: function({ on, attrs }) {
                                        return [
                                          _c(
                                            "v-icon",
                                            _vm._g(
                                              _vm._b(
                                                {
                                                  staticClass: "my-auto ml-1",
                                                  attrs: {
                                                    small: "",
                                                    color: "white"
                                                  }
                                                },
                                                "v-icon",
                                                attrs,
                                                false
                                              ),
                                              on
                                            ),
                                            [_vm._v(" help ")]
                                          )
                                        ]
                                      }
                                    }
                                  ])
                                },
                                [
                                  _c("span", [
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "font-weight-regular white--text caption"
                                      },
                                      [
                                        _vm._v(
                                          " Dados dos últimos " +
                                            _vm._s(
                                              _vm.periodoOptions.find(
                                                opt =>
                                                  opt.value ===
                                                  _vm.periodoSelecionado
                                              )?.text || ""
                                            ) +
                                            " de títulos com os seguintes comandos: 231 (Enviado à desistência), 241 (Enviado à Cancelamento), 251 (Enviado à Anuência), 101 (Pagos) e 107 (Liquidação em condicional) "
                                        )
                                      ]
                                    )
                                  ])
                                ]
                              )
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "v-row",
                        [
                          _c(
                            "v-col",
                            { attrs: { cols: "12" } },
                            [
                              _c("Loading", {
                                attrs: {
                                  active: _vm.carregandoChartRecuperados,
                                  "is-full-page": false
                                }
                              }),
                              _c(
                                "div",
                                { staticClass: "ma-3" },
                                [
                                  !_vm.hasChartData(_vm.dataRecuperados)
                                    ? _c(
                                        "div",
                                        [
                                          _c(
                                            "v-alert",
                                            {
                                              class: _vm.isPartner
                                                ? "bvs-white-label"
                                                : "",
                                              attrs: {
                                                type: "info",
                                                dense: "",
                                                text: ""
                                              }
                                            },
                                            [
                                              _vm._v(
                                                " Nenhum dado disponível para o período selecionado. "
                                              )
                                            ]
                                          )
                                        ],
                                        1
                                      )
                                    : _c("chartRecuperados", {
                                        staticClass: "mt-5",
                                        staticStyle: {
                                          "background-color": "white"
                                        },
                                        attrs: {
                                          height: 300,
                                          "chart-data": _vm.dataRecuperados
                                        }
                                      })
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "v-row",
            { staticClass: "mt-0 mb-4", class: _vm.rowMarginClass },
            [
              _c(
                "v-col",
                {
                  staticClass: "mt-6 pt-0 px-4 pb-4",
                  attrs: { cols: "12", xs: "12", lg: "6" }
                },
                [
                  _c(
                    "v-card",
                    { staticStyle: { height: "100%" } },
                    [
                      _c(
                        "v-sheet",
                        {
                          staticClass: "v-sheet--offset mx-auto",
                          attrs: {
                            color: _vm.colorPainel,
                            elevation: "1",
                            width: "calc(100% - 32px)"
                          }
                        },
                        [
                          _c(
                            "v-card-title",
                            {
                              staticClass: "white--text title font-weight-bold"
                            },
                            [
                              _vm._v(" Valores Enviados para Protesto "),
                              _c(
                                "v-tooltip",
                                {
                                  attrs: { top: "" },
                                  scopedSlots: _vm._u([
                                    {
                                      key: "activator",
                                      fn: function({ on, attrs }) {
                                        return [
                                          _c(
                                            "v-icon",
                                            _vm._g(
                                              _vm._b(
                                                {
                                                  staticClass: "my-auto ml-1",
                                                  attrs: {
                                                    small: "",
                                                    color: "white"
                                                  }
                                                },
                                                "v-icon",
                                                attrs,
                                                false
                                              ),
                                              on
                                            ),
                                            [_vm._v(" help ")]
                                          )
                                        ]
                                      }
                                    }
                                  ])
                                },
                                [
                                  _c("span", [
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "font-weight-regular white--text caption"
                                      },
                                      [
                                        _vm._v(
                                          " Valores totais enviados para protesto nos últimos " +
                                            _vm._s(
                                              _vm.periodoOptions.find(
                                                opt =>
                                                  opt.value ===
                                                  _vm.periodoSelecionado
                                              )?.text || ""
                                            ) +
                                            ". "
                                        )
                                      ]
                                    )
                                  ])
                                ]
                              )
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "v-row",
                        [
                          _c(
                            "v-col",
                            { attrs: { cols: "12" } },
                            [
                              _c("Loading", {
                                attrs: {
                                  active: _vm.carregandoValoresEnviados,
                                  "is-full-page": false
                                }
                              }),
                              _c(
                                "div",
                                { staticClass: "ma-3" },
                                [
                                  !_vm.hasChartData(_vm.dataValoresEnviados)
                                    ? _c(
                                        "div",
                                        [
                                          _c(
                                            "v-alert",
                                            {
                                              class: _vm.isPartner
                                                ? "bvs-white-label"
                                                : "",
                                              attrs: {
                                                type: "info",
                                                dense: "",
                                                text: ""
                                              }
                                            },
                                            [
                                              _vm._v(
                                                " Nenhum dado disponível para o período selecionado. "
                                              )
                                            ]
                                          )
                                        ],
                                        1
                                      )
                                    : _c("chartTotalUploads", {
                                        staticClass: "mt-5",
                                        staticStyle: {
                                          "background-color": "white"
                                        },
                                        attrs: {
                                          height: 300,
                                          color: "red",
                                          "chart-data": _vm.dataValoresEnviados
                                        }
                                      })
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "v-col",
                {
                  staticClass: "mt-6 pt-0 px-4 pb-4",
                  attrs: { cols: "12", xs: "12", lg: "6" }
                },
                [
                  _c(
                    "v-card",
                    { staticStyle: { height: "100%" } },
                    [
                      _c(
                        "v-sheet",
                        {
                          staticClass: "v-sheet--offset mx-auto",
                          attrs: {
                            color: _vm.colorPainel,
                            elevation: "1",
                            width: "calc(100% - 32px)"
                          }
                        },
                        [
                          _c(
                            "v-card-title",
                            {
                              staticClass: "white--text title font-weight-bold"
                            },
                            [
                              _vm._v(" Valores Recuperados "),
                              _c(
                                "v-tooltip",
                                {
                                  attrs: { top: "" },
                                  scopedSlots: _vm._u([
                                    {
                                      key: "activator",
                                      fn: function({ on, attrs }) {
                                        return [
                                          _c(
                                            "v-icon",
                                            _vm._g(
                                              _vm._b(
                                                {
                                                  staticClass: "my-auto ml-1",
                                                  attrs: {
                                                    small: "",
                                                    color: "white"
                                                  }
                                                },
                                                "v-icon",
                                                attrs,
                                                false
                                              ),
                                              on
                                            ),
                                            [_vm._v(" help ")]
                                          )
                                        ]
                                      }
                                    }
                                  ])
                                },
                                [
                                  _c("span", [
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "font-weight-regular white--text caption"
                                      },
                                      [
                                        _vm._v(
                                          " Valores totais recuperados por status nos últimos " +
                                            _vm._s(
                                              _vm.periodoOptions.find(
                                                opt =>
                                                  opt.value ===
                                                  _vm.periodoSelecionado
                                              )?.text || ""
                                            ) +
                                            ". "
                                        )
                                      ]
                                    )
                                  ])
                                ]
                              )
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "v-row",
                        [
                          _c(
                            "v-col",
                            { attrs: { cols: "12" } },
                            [
                              _c("Loading", {
                                attrs: {
                                  active: _vm.carregandoValoresRecuperados,
                                  "is-full-page": false
                                }
                              }),
                              _c(
                                "div",
                                { staticClass: "ma-3" },
                                [
                                  !_vm.hasChartData(_vm.dataValoresRecuperados)
                                    ? _c(
                                        "div",
                                        [
                                          _c(
                                            "v-alert",
                                            {
                                              class: _vm.isPartner
                                                ? "bvs-white-label"
                                                : "",
                                              attrs: {
                                                type: "info",
                                                dense: "",
                                                text: ""
                                              }
                                            },
                                            [
                                              _vm._v(
                                                " Nenhum dado disponível para o período selecionado. "
                                              )
                                            ]
                                          )
                                        ],
                                        1
                                      )
                                    : _c("chartTotalUploads", {
                                        staticClass: "mt-5",
                                        staticStyle: {
                                          "background-color": "white"
                                        },
                                        attrs: {
                                          height: 300,
                                          color: "red",
                                          "chart-data":
                                            _vm.dataValoresRecuperados
                                        }
                                      })
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "v-row",
            { staticClass: "mt-0 mb-4", class: _vm.rowMarginClass },
            [
              _c(
                "v-col",
                {
                  staticClass: "mt-6 pt-0 px-4 pb-4",
                  attrs: { cols: "12", xs: "12", lg: "12" }
                },
                [
                  _c(
                    "v-card",
                    { staticClass: "mt-2 mx-auto" },
                    [
                      _c(
                        "v-sheet",
                        {
                          staticClass: "v-sheet--offset mx-auto",
                          attrs: {
                            color: _vm.colorPainel,
                            elevation: "1",
                            width: "calc(100% - 32px)"
                          }
                        },
                        [
                          _c(
                            "v-card-title",
                            {
                              staticClass: "white--text title font-weight-bold"
                            },
                            [_vm._v(" Resumo de Títulos Existentes ")]
                          )
                        ],
                        1
                      ),
                      _c("v-data-table", {
                        directives: [
                          {
                            name: "intersect",
                            rawName: "v-intersect",
                            value: _vm.onIntersect,
                            expression: "onIntersect"
                          }
                        ],
                        staticClass: "elevation-1",
                        attrs: {
                          headers: _vm.headers,
                          items: _vm.titulosExistentes,
                          "header-props": _vm.headerProps,
                          loading: _vm.carregandoDataTable,
                          "hide-default-footer": "",
                          "disable-pagination": "",
                          dense: "",
                          "fixed-header": ""
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: `item.ds_status`,
                              fn: function({ item }) {
                                return [
                                  _c(
                                    "span",
                                    {
                                      style: {
                                        fontWeight:
                                          item.ds_status ===
                                          "Irregulares Não Reapresentados"
                                            ? "bold"
                                            : "normal"
                                      }
                                    },
                                    [
                                      _vm._v(
                                        " " + _vm._s(item.ds_status) + " "
                                      ),
                                      item.ds_status ===
                                      "Irregulares Não Reapresentados"
                                        ? [
                                            _c(
                                              "a",
                                              {
                                                staticClass: "ml-2",
                                                attrs: {
                                                  href:
                                                    "/consulta-titulos?irregularesNaoReapresentados=1",
                                                  target: "_blank",
                                                  rel: "noopener noreferrer"
                                                }
                                              },
                                              [
                                                _c(
                                                  "v-icon",
                                                  { attrs: { small: "" } },
                                                  [_vm._v("mdi-open-in-new")]
                                                )
                                              ],
                                              1
                                            )
                                          ]
                                        : _vm._e()
                                    ],
                                    2
                                  ),
                                  _c(
                                    "v-tooltip",
                                    {
                                      attrs: { top: "" },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "activator",
                                            fn: function({ on, attrs }) {
                                              return [
                                                _c(
                                                  "v-icon",
                                                  _vm._g(
                                                    _vm._b(
                                                      {
                                                        staticClass:
                                                          "my-auto ml-1",
                                                        attrs: {
                                                          small: "",
                                                          color: "grey"
                                                        }
                                                      },
                                                      "v-icon",
                                                      attrs,
                                                      false
                                                    ),
                                                    on
                                                  ),
                                                  [_vm._v(" help ")]
                                                )
                                              ]
                                            }
                                          }
                                        ],
                                        null,
                                        true
                                      )
                                    },
                                    [
                                      _c("span", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.getTooltipByStatus(
                                              item.ds_status
                                            )
                                          )
                                        )
                                      ])
                                    ]
                                  )
                                ]
                              }
                            }
                          ],
                          null,
                          true
                        )
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "v-row",
            [
              _c(
                "v-card",
                { staticClass: "mt-2 mb-8 mx-auto" },
                [
                  _c(
                    "v-expansion-panels",
                    { on: { change: _vm.onPanelChange } },
                    [
                      _c(
                        "v-expansion-panel",
                        [
                          _c(
                            "v-expansion-panel-header",
                            { attrs: { "hide-actions": "" } },
                            [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "d-flex align-center justify-center",
                                  staticStyle: { width: "100%" }
                                },
                                [
                                  _c(
                                    "div",
                                    { staticClass: "d-flex align-center" },
                                    [
                                      _c("v-sheet", {
                                        staticClass: "v-sheet--offset mr-4",
                                        attrs: {
                                          color: _vm.colorPainel,
                                          elevation: "12",
                                          "max-width": "fit-content"
                                        }
                                      }),
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "font-weight-bold d-flex align-center",
                                          staticStyle: {
                                            "font-size": "1.25rem"
                                          },
                                          style: {
                                            color: _vm.titleColorFont
                                          }
                                        },
                                        [
                                          _vm._v(
                                            " Relatório de E-mails dos últimos 90 dias "
                                          ),
                                          _c(
                                            "v-icon",
                                            { staticClass: "ml-2" },
                                            [_vm._v(_vm._s(_vm.showIcon))]
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ]
                              )
                            ]
                          ),
                          _c(
                            "v-expansion-panel-content",
                            [
                              _c(
                                "v-col",
                                {
                                  staticStyle: {
                                    "padding-bottom": "0px",
                                    "padding-top": "0px"
                                  }
                                },
                                [
                                  _c(
                                    "v-row",
                                    {
                                      staticStyle: {
                                        "padding-bottom": "0px",
                                        "padding-top": "0px"
                                      }
                                    },
                                    [
                                      _c(
                                        "v-col",
                                        {
                                          staticStyle: { display: "grid" },
                                          attrs: { sm: "6", lg: "3" }
                                        },
                                        [
                                          _c(
                                            "div",
                                            { staticClass: "grey--text" },
                                            [_vm._v(" E-mails Enviados ")]
                                          ),
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "font-weight-bold display-1 d-flex justify-center align-end",
                                              style: {
                                                color: _vm.titleColorFont
                                              }
                                            },
                                            [
                                              _vm.carregandoRelatorioEmails
                                                ? _c("v-progress-circular", {
                                                    attrs: {
                                                      color: "primary",
                                                      small: "",
                                                      indeterminate: ""
                                                    }
                                                  })
                                                : _c("div", [
                                                    _vm._v(
                                                      " " +
                                                        _vm._s(
                                                          _vm.relatorioEmails
                                                            .emails_enviados
                                                        ) +
                                                        " "
                                                    )
                                                  ])
                                            ],
                                            1
                                          )
                                        ]
                                      ),
                                      _c(
                                        "v-col",
                                        {
                                          staticStyle: { display: "grid" },
                                          attrs: { sm: "6", lg: "3" }
                                        },
                                        [
                                          _c(
                                            "div",
                                            { staticClass: "grey--text" },
                                            [_vm._v(" E-mails Recebidos ")]
                                          ),
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "font-weight-bold display-1 d-flex justify-center align-end",
                                              style: {
                                                color: _vm.titleColorFont
                                              }
                                            },
                                            [
                                              _vm.carregandoRelatorioEmails
                                                ? _c("v-progress-circular", {
                                                    attrs: {
                                                      color: "primary",
                                                      small: "",
                                                      indeterminate: ""
                                                    }
                                                  })
                                                : _c("div", [
                                                    _vm._v(
                                                      " " +
                                                        _vm._s(
                                                          _vm.relatorioEmails
                                                            .emails_recebidos
                                                        ) +
                                                        " "
                                                    )
                                                  ])
                                            ],
                                            1
                                          )
                                        ]
                                      ),
                                      _c(
                                        "v-col",
                                        {
                                          staticStyle: { display: "grid" },
                                          attrs: { sm: "6", lg: "3" }
                                        },
                                        [
                                          _c(
                                            "div",
                                            { staticClass: "grey--text" },
                                            [_vm._v(" E-mails Abertos ")]
                                          ),
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "font-weight-bold display-1 d-flex justify-center align-end",
                                              style: {
                                                color: _vm.titleColorFont
                                              }
                                            },
                                            [
                                              _vm.carregandoRelatorioEmails
                                                ? _c("v-progress-circular", {
                                                    attrs: {
                                                      color: "primary",
                                                      small: "",
                                                      indeterminate: ""
                                                    }
                                                  })
                                                : _c("div", [
                                                    _vm._v(
                                                      " " +
                                                        _vm._s(
                                                          _vm.relatorioEmails
                                                            .emails_abertos
                                                        ) +
                                                        " "
                                                    )
                                                  ])
                                            ],
                                            1
                                          )
                                        ]
                                      ),
                                      _c(
                                        "v-col",
                                        {
                                          staticStyle: { display: "grid" },
                                          attrs: { sm: "6", lg: "3" }
                                        },
                                        [
                                          _c(
                                            "div",
                                            { staticClass: "grey--text" },
                                            [
                                              _vm._v(
                                                " E-mails com link acessado "
                                              )
                                            ]
                                          ),
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "font-weight-bold display-1 d-flex justify-center align-end",
                                              style: {
                                                color: _vm.titleColorFont
                                              }
                                            },
                                            [
                                              _vm.carregandoRelatorioEmails
                                                ? _c("v-progress-circular", {
                                                    attrs: {
                                                      color: "primary",
                                                      small: "",
                                                      indeterminate: ""
                                                    }
                                                  })
                                                : _c("div", [
                                                    _vm._v(
                                                      " " +
                                                        _vm._s(
                                                          _vm.relatorioEmails
                                                            .emails_com_link_de_contato_acessado
                                                        ) +
                                                        " "
                                                    )
                                                  ])
                                            ],
                                            1
                                          )
                                        ]
                                      )
                                    ],
                                    1
                                  ),
                                  _c("v-divider", { staticClass: "my-1" }),
                                  _c(
                                    "v-icon",
                                    {
                                      staticClass: "mr-2",
                                      attrs: { small: "" }
                                    },
                                    [_vm._v(" mdi-clock ")]
                                  ),
                                  _c(
                                    "span",
                                    {
                                      staticClass:
                                        "caption grey--text font-weight-light"
                                    },
                                    [_vm._v("Atualizado desde o último acesso")]
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm.mostrarModalConfirmacao
        ? _c("ConfirmacaoModal", {
            attrs: {
              showDialog: _vm.mostrarModalConfirmacao,
              tituloModal: _vm.tituloModalConfirmacao,
              textoModal: _vm.textoModalConfirmacao,
              btnConfirmarEmit: _vm.btnConfirmarModalConfirmacao,
              btnConfirmar: "Ok",
              esconderCancelar: _vm.esconderCancelar
            },
            on: {
              confirmarAviso: _vm.aceitarModalAviso,
              fecharModal: _vm.aceitarModalAviso
            }
          })
        : _vm._e(),
      _c(
        "v-dialog",
        {
          attrs: {
            "max-width": _vm.isFullscreen ? "100vw" : "600px",
            "max-height": _vm.isFullscreen ? "100vh" : "80vh",
            "overlay-opacity": "0.9",
            persistent: _vm.loadingImagem
          },
          on: {
            "click:outside": function($event) {
              _vm.loadingImagem ? null : _vm.fecharImagemExpandida
            }
          },
          model: {
            value: _vm.dialogImagemExpandida,
            callback: function($$v) {
              _vm.dialogImagemExpandida = $$v
            },
            expression: "dialogImagemExpandida"
          }
        },
        [
          _vm.imagemSelecionada
            ? _c(
                "v-card",
                { staticClass: "pa-0" },
                [
                  _c(
                    "v-toolbar",
                    { attrs: { color: "primary", dark: "" } },
                    [
                      _c("v-toolbar-title", [
                        _vm._v(_vm._s(_vm.imagemSelecionada.assunto))
                      ]),
                      _c("v-spacer"),
                      _c(
                        "v-btn",
                        {
                          attrs: { icon: "", disabled: _vm.loadingImagem },
                          on: { click: _vm.fecharImagemExpandida }
                        },
                        [
                          _vm.loadingImagem
                            ? _c("v-progress-circular", {
                                attrs: { indeterminate: "", size: "20" }
                              })
                            : _c("v-icon", [_vm._v("mdi-close")])
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "v-card-text",
                    { staticClass: "pa-4" },
                    [
                      _c("v-img", {
                        class: _vm.loadingImagem ? "" : "cursor-pointer",
                        staticStyle: {
                          width: "100%",
                          height: "100%",
                          "object-fit": "cover"
                        },
                        style: _vm.isFullscreen
                          ? {
                              position: "fixed",
                              top: "0",
                              left: "0",
                              width: "100vw",
                              height: "100vh",
                              zIndex: 9999,
                              backgroundColor: "black"
                            }
                          : {},
                        attrs: {
                          src: _vm.imagemSelecionada.imagem_url,
                          alt: _vm.imagemSelecionada.assunto,
                          contain: ""
                        },
                        on: {
                          click: function($event) {
                            _vm.loadingImagem
                              ? null
                              : (_vm.isFullscreen = !_vm.isFullscreen)
                          }
                        }
                      }),
                      _c("div", { staticClass: "mt-4" }, [
                        _c("p", [
                          _c("strong", [_vm._v("Assunto:")]),
                          _vm._v(
                            " " + _vm._s(_vm.imagemSelecionada.assunto) + " "
                          )
                        ]),
                        _c("p", [
                          _c("strong", [_vm._v("Data de Envio:")]),
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.formatarData(
                                  _vm.imagemSelecionada.data_envio
                                )
                              ) +
                              " "
                          )
                        ]),
                        _c("p", [
                          _c("strong", [_vm._v("Enviada por:")]),
                          _vm._v(
                            " " +
                              _vm._s(_vm.imagemSelecionada.user.nm_user) +
                              " (" +
                              _vm._s(_vm.imagemSelecionada.user.ds_email) +
                              ") "
                          )
                        ]),
                        _c("p", { staticClass: "text-center grey--text" }, [
                          _vm._v(" Clique na imagem para abrir em tela cheia ")
                        ])
                      ])
                    ],
                    1
                  ),
                  _c(
                    "v-card-actions",
                    { staticClass: "justify-center pa-2" },
                    [
                      _c(
                        "v-btn",
                        {
                          attrs: {
                            color: "primary",
                            disabled: _vm.loadingImagem
                          },
                          on: {
                            click: function($event) {
                              return _vm.baixarImagem(_vm.imagemSelecionada)
                            }
                          }
                        },
                        [
                          _c("v-icon", { attrs: { left: "" } }, [
                            _vm._v("mdi-download")
                          ]),
                          _vm._v(" Baixar Imagem ")
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            : _vm._e()
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }